import { runtimeAssetPath } from '../services/runtime-config';

export const formatPrice = (value: number) => `${new Intl.NumberFormat('ru-RU').format(value)}\u00a0₽`;
export const escapeHtml = (value: string | number | null | undefined) => String(value ?? '').replace(/[&<>'"]/g, (symbol) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' })[symbol] ?? symbol);
export const formatPortion = (portion: string | number | null | undefined, unit: string | null | undefined) => {
  const value = String(portion ?? '').trim();
  if (!value || (/^[\d.,]+$/.test(value) && Number(value.replace(',', '.')) <= 0)) return '';
  const sourceUnit = String(unit ?? '').trim();
  const normalizedUnit = /^(gram|grams|г|гр|гр\.)$/i.test(sourceUnit) ? 'г' : sourceUnit || 'г';
  return `${value}\u00a0${normalizedUnit}`;
};
type Debounced<T extends (...args: never[]) => void> = ((...args: Parameters<T>) => void) & { cancel: () => void };

export const debounce = <T extends (...args: never[]) => void>(callback: T, delay = 180): Debounced<T> => {
  let timer = 0;
  const debounced = ((...args: Parameters<T>) => {
    clearTimeout(timer);
    timer = window.setTimeout(() => callback(...args), delay);
  }) as Debounced<T>;
  debounced.cancel = () => { clearTimeout(timer); timer = 0; };
  return debounced;
};
export const safeImageUrl = (url: string) => {
  const source = runtimeAssetPath(String(url ?? '').trim());
  const allowed = /^(https?:\/\/|\/)/i.test(source) || /^blob:https?:\/\//i.test(source);
  return allowed ? encodeURI(source).replace(/["']/g, (symbol) => symbol === '"' ? '%22' : '%27') : runtimeAssetPath('/icons/app-icon.svg');
};
export const imageStyle = (url: string, position = 'center') => {
  return `style="--image: url('${safeImageUrl(url)}');--image-position:${position.replace(/[^\w% -]/g, '')}"`;
};
